import React from "react";
import { ArticleFeed } from "./articleFeed";
import type { FeedsSectionProps } from "./types";

export const FeedsSectionContent: React.FC<FeedsSectionProps> = ({
  sectionData,
}) => {
  return (
    <ArticleFeed
      popularArticles={sectionData.popularArticles}
      freeToReadArticles={sectionData.freeToReadArticles}
      collaborationArticles={sectionData.collaborationArticles}
      tabLabels={sectionData.tabLabels}
      tabOrder={sectionData.tabOrder}
      ctaText={sectionData.ctaText}
      ctaLink={sectionData.ctaLink}
      secondTabCta={sectionData.secondTabCta}
      thirdTabCta={sectionData.thirdTabCta}
    />
  );
};

export const FeedsSection: React.FC<FeedsSectionProps> = (props) => {
  return (
    <div className="w-full pb-0 pt-0">
      <FeedsSectionContent {...props} />
    </div>
  );
};

export default FeedsSection;
